var exports = {
  "kL": "xf0b3b88a--ab441c--container",
  "UU": "xf0b3b88a--ab441c--name",
  "x": "xf0b3b88a--ab441c--offer",
  "nf": "xf0b3b88a--ab441c--link",
};

module.exports = exports;
